import { Logger, SupportedProducts } from 'atp-api-logger';

import { config } from '@/_config';

export const logger = Logger.getInstance(SupportedProducts.PREP_PORTAL, config.isProduction);
